// extracted by mini-css-extract-plugin
export default {"root":"tugJmgz6rz","list":"VKfA1Ham2k"};